import { render, staticRenderFns } from "./EduTitle.vue?vue&type=template&id=202ebb75&"
import script from "./EduTitle.vue?vue&type=script&lang=ts&"
export * from "./EduTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports